<template>
    <div class="usp-list">
        <div v-if="availability"
        :class="[classes, 'availability-top']"
        :style="paddingStyles">
            <i class="fa fa-clock-o"></i>
            <span class="text-wrap" :class="{'text-dark': availability && availability.id === 2}">{{ name }}</span>
        </div>
        <!-- <div v-if="availability"
            :class="[classes, 'calculated-save', 'availability-bottom']"
            :style="paddingStyles">
            <span class="text-wrap">
                {{ name }}
            </span>
        </div> -->
    </div>
</template>

<script>
export default {
    name: "item-availability",

    props: {
        paddingClasses: String,
        paddingStyles: String
    },

    inject: {
        itemId: {
            default: null
        }
    },

    computed:
    {
        availability() {
            const currentVariation = this.$store.getters[`${this.itemId}/currentItemVariation`];
            return currentVariation && currentVariation.variation && currentVariation.variation.availability;
        },

        classes() {
            return [
                "availability",
                "badge",
                "availability-" + (this.availability && this.availability.id),
                this.paddingClasses
            ];
        },

        name() {
            return this.availability && this.availability.names && this.availability.names.name;
        }
    }
}
</script>
